import { create } from 'zustand';

const useConnectModalStore = create((set) => ({
  open: false,
  company: null,
  setOpen: (isOpen, company) =>
    set(() => ({ open: isOpen, company: company || null })),
  connect: () => {},
}));

export default useConnectModalStore;
